import { useEffect, useState } from "react";
import { Loader } from "@/components/common";

// Fetches a file as a blob (auth headers) and shows images inline and PDFs in the browser viewer.
export default function FilePreview({ load, file, testid = "file-preview" }) {
  const [url, setUrl] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    let u = null; let live = true;
    setUrl(null); setErr(false);
    load().then((blob) => { if (!live) return; u = URL.createObjectURL(blob); setUrl(u); }).catch(() => live && setErr(true));
    return () => { live = false; if (u) URL.revokeObjectURL(u); };
  }, [load]);
  if (err) return <p className="rounded-xl bg-q-raised p-6 text-center text-sm text-q-muted" data-testid={`${testid}-error`}>This file can't be shown right now.</p>;
  if (!url) return <Loader label="Opening…" />;
  if (file.mime === "application/pdf") return <iframe title={file.name} src={url} className="h-[60vh] w-full rounded-xl border border-q-line bg-white" data-testid={`${testid}-pdf`} />;
  return <img src={url} alt={file.name} className="mx-auto max-h-[60vh] w-auto max-w-full rounded-xl object-contain" data-testid={`${testid}-image`} />;
}
